import { useContext } from 'react';
import { ChatUIContext } from '../context/ChatUIContext';
/**
 * Custom hook to access the UI context values.
 * Must be used within a UIContextProvider component.
 * @returns The UI context value
 * @public
 */
export const useChatUIContext = () => {
  const context = useContext(ChatUIContext);
  if (!context) {
    throw new Error('useUIContext must be used within a UIContextProvider');
  }
  return context;
};